module.exports = __webpack_public_path__ + "img/DAVID_CANNON_10-rs.20d1e021.jpg";